import React from 'react';
import '../css/Disclaimer.css';

const Disclaimer = (props) => {

	return (
		<div className="app__disclaimer">
			<span className='app__button-reset app__disclaimer--toggle'>
				{props.content.disclaimerTitle}
			</span>
			<div className="app__disclaimer-copy">
				<p>{props.content.disclaimerText}</p>
			</div>
		</div>
	);
}

export default Disclaimer;



// WEBPACK FOOTER //
// ./src/components/Disclaimer.js